import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Zoom,
  Box,
  Typography,
} from "@mui/material";

const JumboConfirmDialog = ({
  icon,
  title,
  subheader,
  message,
  open,
  onConfirm,
  onClose,
  maxWidth = "xs",
  cancelText = "Cancel",
  confirmText = "Confirm",
  cancelColor = "error",
  confirmColor = "success",
  confirmVariant = "contained",
}) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Zoom}
      keepMounted
      onClose={onClose}
      maxWidth={maxWidth}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle
        id="confirmation-dialog-title"
        sx={{ paddingTop: "22px", paddingBottom: "8px", fontSize: 18 }}
      >
        {icon && <Box sx={{ display: "inline-block", mr: 1 }}>{icon}</Box>}
        {title}
      </DialogTitle>
      <DialogContent sx={{ pb: 1, my: 0 }}>
        {subheader && (
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ mb: 1 }}
            id="confirmation-dialog-subheader"
          >
            {subheader}
          </Typography>
        )}
        <DialogContentText id="confirmation-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color={cancelColor}>
          {cancelText}
        </Button>
        <Button
          onClick={() => {
            if (typeof onConfirm === "function") onConfirm();
            onClose();
          }}
          color={confirmColor}
          variant={confirmVariant}
          autoFocus
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

JumboConfirmDialog.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  subheader: PropTypes.node,
  message: PropTypes.node,
  open: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  cancelColor: PropTypes.string,
  confirmColor: PropTypes.string,
  confirmVariant: PropTypes.string,
};

export default JumboConfirmDialog;
